module.exports = __webpack_public_path__ + "img/xtgl3.87e046dc.png";